/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseApiOverviewDTO } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GaiLanYeGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GaiLanYeGuanLi
   * @name GetOverviewUsingPost
   * @summary 获取概览数据
   * @request POST:/dsp-admin/api/overview
   * @secure
   */
  getOverviewUsingPost = (
    query?: {
      /**
       * 广告主ID（可选）
       * @format int64
       */
      advertiserId?: number;
      /** 日期范围快捷选择（today/yesterday/last7days/last30days/thisMonth/lastMonth） */
      dateRange?: string;
      /** 结束日期（格式：yyyy-MM-dd） */
      endDate?: string;
      /** 开始日期（格式：yyyy-MM-dd） */
      startDate?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiOverviewDTO, void>({
      path: `/dsp-admin/api/overview`,
      method: "POST",
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GaiLanYeGuanLi();
